import { useEffect, useState } from 'react';
import { IconCopyOutline } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { t } from '@lingui/macro';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Tooltip } from 'react-tooltip';
import { v4 } from 'uuid';
import styles from './CopyButton.module.css';

type TProps = {
  text: string;
  onCopy?: (text: string) => void;
  buttonClassName?: string;
  testId?: string;
};

export const CopyButton = ({
  text,
  onCopy,
  testId,
  buttonClassName,
}: TProps) => {
  const [labelText, setLabelText] = useState(t`Copy`);
  const [hasCopied, setHasCopied] = useState(false);
  const [copyId] = useState(v4());

  useEffect(() => {
    let timeOut: NodeJS.Timeout | undefined;

    if (hasCopied) {
      clearTimeout(timeOut);
      setLabelText(t`Copied!`);
    } else {
      timeOut = setTimeout(() => {
        setLabelText(t`Copy`);
      }, 2000);
    }

    return () => {
      clearTimeout(timeOut);
    };
  }, [hasCopied]);

  const handleOnCopy = (text: string) => {
    onCopy?.(text);
    setHasCopied(true);
  };

  return (
    <CopyToClipboard text={text} onCopy={handleOnCopy}>
      {
        <Button
          variant="tertiary"
          size="small"
          data-testid={testId || 'copy-button'}
          data-tooltip-id={copyId}
          onMouseLeave={() => setHasCopied(false)}
          onMouseEnter={() => setLabelText(t`Copy`)}
          className={buttonClassName}
        >
          <IconCopyOutline height={20} width={20} />

          {/* TODO: Replace with Orion's upcoming dynamic tooltip when its built and uninstall react-tooltip  */}
          <Tooltip
            className={styles.tooltip}
            id={copyId}
            opacity={1}
            content={labelText}
            openEvents={{ focus: false, mouseenter: true }}
            place="bottom"
            border="1px solid var(--color-structure-80)"
          />
        </Button>
      }
    </CopyToClipboard>
  );
};
